import { popupStore } from '../../../../store/popupStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isMobile } from '../../../../core/helpers/isMobile';
import { isTopC } from '../../../../core/helpers/skinHelper';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import cardImg from '../../../../assets/images/handBj/cards.png';
import cardsBack from '../../../../assets/images/handBj/bj-backside-cards.png';
import cardBack from '../../../../assets/images/handBj/card-back-side.png';
import chipHolder from '../../../../assets/images/handBj/chip-holder.png';

export const HAND_BLACKJACK_GAME_ID = 108;

export const GameAllImages = [cardImg, cardsBack, cardBack, chipHolder];

export const BlackJackGameMode = {
  Normal: 0,
  Turbo: 1,
};

export const SOCKET_INVOKE_TARGETS = {
  0: 'Hit',
  1: 'Stand',
  2: 'Double',
  3: 'Split',
  4: 'Surrender',
};

export const DECISIONS_MODELS = [
  { type: 0, name: 'HIT', iconName: 'icon-plus cpt-plus', className: 'green', isBet: false },
  { type: 1, name: 'STAND', iconName: 'icon-stand cpt-stand', className: 'red', isBet: false },
  { type: 3, name: 'SPLIT', iconName: 'icon-split cpt-split', className: 'blue', isBet: true },
  { type: 2, name: 'DOUBLE', iconName: 'icon-double cpt-double', className: 'yellow', isBet: true },
  {
    type: 4,
    name: 'SURRENDER',
    iconName: 'icon-flag cpt-flag',
    className: 'purple full-size',
    isBet: true,
  },
];

export const DEALER_CARD = 1;

export const SOCKET_DECISIONS_METHODS = {
  HitResult: 'HitResult',
  StandResult: 'StandResult',
  SplitResult: 'SplitResult',
  DoubleResult: 'DoubleResult',
  SurrenderResult: 'SurrenderResult',
  InsuranceResult: 'InsuranceResult',
  InsuranceInfoResult: 'InsuranceInfoResult',
};

export const ADDITIONAL_PARAMS_TYPE = {
  MAIN_BET: 0,
  SPLIT_BET: 1,
  DOUBLE: 2,
  INSURANCE_BET: 3,
};

export const INSURANCE_TYPE = 5;

export const DECISION_TYPE = {
  hit: 0,
  stand: 1,
  double: 2,
  split: 3,
  surrender: 4,
};

export const CARDS = {
  SPADES_ACE: 0,
  SPADES_2: 1,
  SPADES_3: 2,
  SPADES_4: 3,
  SPADES_5: 4,
  SPADES_6: 5,
  SPADES_7: 6,
  SPADES_8: 7,
  SPADES_9: 8,
  SPADES_10: 9,
  SPADES_JACK: 10,
  SPADES_QUEEN: 11,
  SPADES_KING: 12,
  HEARTS_ACE: 13,
  HEARTS_2: 14,
  HEARTS_3: 15,
  HEARTS_4: 16,
  HEARTS_5: 17,
  HEARTS_6: 18,
  HEARTS_7: 19,
  HEARTS_8: 20,
  HEARTS_9: 21,
  HEARTS_10: 22,
  HEARTS_JACK: 23,
  HEARTS_QUEEN: 24,
  HEARTS_KING: 25,
  DIAMONDS_ACE: 26,
  DIAMONDS_2: 27,
  DIAMONDS_3: 28,
  DIAMONDS_4: 29,
  DIAMONDS_5: 30,
  DIAMONDS_6: 31,
  DIAMONDS_7: 32,
  DIAMONDS_8: 33,
  DIAMONDS_9: 34,
  DIAMONDS_10: 35,
  DIAMONDS_JACK: 36,
  DIAMONDS_QUEEN: 37,
  DIAMONDS_KING: 38,
  CLUBS_ACE: 39,
  CLUBS_2: 40,
  CLUBS_3: 41,
  CLUBS_4: 42,
  CLUBS_5: 43,
  CLUBS_6: 44,
  CLUBS_7: 45,
  CLUBS_8: 46,
  CLUBS_9: 47,
  CLUBS_10: 48,
  CLUBS_JACK: 49,
  CLUBS_QUEEN: 50,
  CLUBS_KING: 51,
  CUTTING_CARD: 52,
  UNKNOWN: 53,
};

export const toPoint = (card, cardSum = 0) => {
  switch (card) {
    case CARDS.CLUBS_ACE:
    case CARDS.DIAMONDS_ACE:
    case CARDS.HEARTS_ACE:
    case CARDS.SPADES_ACE:
      if (cardSum + 11 > 21) return 1;
      return 11;
    case CARDS.CLUBS_2:
    case CARDS.DIAMONDS_2:
    case CARDS.HEARTS_2:
    case CARDS.SPADES_2:
      return 2;
    case CARDS.CLUBS_3:
    case CARDS.DIAMONDS_3:
    case CARDS.HEARTS_3:
    case CARDS.SPADES_3:
      return 3;
    case CARDS.CLUBS_4:
    case CARDS.DIAMONDS_4:
    case CARDS.HEARTS_4:
    case CARDS.SPADES_4:
      return 4;
    case CARDS.CLUBS_5:
    case CARDS.DIAMONDS_5:
    case CARDS.HEARTS_5:
    case CARDS.SPADES_5:
      return 5;
    case CARDS.CLUBS_6:
    case CARDS.DIAMONDS_6:
    case CARDS.HEARTS_6:
    case CARDS.SPADES_6:
      return 6;
    case CARDS.CLUBS_7:
    case CARDS.DIAMONDS_7:
    case CARDS.HEARTS_7:
    case CARDS.SPADES_7:
      return 7;
    case CARDS.CLUBS_8:
    case CARDS.DIAMONDS_8:
    case CARDS.HEARTS_8:
    case CARDS.SPADES_8:
      return 8;
    case CARDS.CLUBS_9:
    case CARDS.DIAMONDS_9:
    case CARDS.HEARTS_9:
    case CARDS.SPADES_9:
      return 9;
    case CARDS.CLUBS_10:
    case CARDS.DIAMONDS_10:
    case CARDS.HEARTS_10:
    case CARDS.SPADES_10:
    case CARDS.CLUBS_JACK:
    case CARDS.DIAMONDS_JACK:
    case CARDS.HEARTS_JACK:
    case CARDS.SPADES_JACK:
    case CARDS.CLUBS_QUEEN:
    case CARDS.DIAMONDS_QUEEN:
    case CARDS.HEARTS_QUEEN:
    case CARDS.SPADES_QUEEN:
    case CARDS.CLUBS_KING:
    case CARDS.DIAMONDS_KING:
    case CARDS.HEARTS_KING:
    case CARDS.SPADES_KING:
      return 10;
    default:
      return 0;
  }
};
export const DECK_ACE_CARDS = [0, 13, 26, 39];

export const BET_WIN_TYPE = {
  BlackJack: 8,
  Lose: 9,
  Win: 10,
  Surrender: 11,
  Push: 12,
};

export const ACTION_TYPE = {
  0: 'MAIN_BET',
  1: 'SPLIT',
  2: 'DOUBLE',
  3: 'INSURANCE',
  4: 'SURRENDER',
};

export const HandBlackJackBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const HandBlackJackBetHistoryColumns = [
  {
    title: TranslationKeys.BetId,
    dataKey: 'spinId',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({
            name: PopupTypes.Fairness,
            spinInfo: { ...spinInfo, id: spinInfo.spinId },
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Actions,
    dataKey: '',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    additionalInfoRenderer: (spinInfo, t) => t(ACTION_TYPE[spinInfo.type]),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const HAND_BJ_RULES_KEYS = new Array(36).fill(null).map((item, index) => index + 1);
export const HAND_BJ_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
